import { render, staticRenderFns } from "./searchIdName.vue?vue&type=template&id=8d8a1c20&"
import script from "./searchIdName.vue?vue&type=script&lang=js&"
export * from "./searchIdName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports